import React from 'react';

import { BatchDetailPanel } from '../BatchDetailPanel';
import { BatchRunDrawer } from '../BatchRunDrawer';

export function BatchesMainPanel({
  drawerProps,
  projects,
  selectedBatchId,
  initialSampleId,
  initialPipeline,
  onDrawerClose,
  onBatchCreated,
  onBatchFinalized,
}) {
  const showingInlineBatchForm =
    drawerProps?.mode?.startsWith('batch') && !drawerProps?.batchId;

  if (showingInlineBatchForm) {
    return (
      <BatchRunDrawer
        open={true}
        onClose={onDrawerClose}
        onCreated={(batch) => onBatchCreated(batch)}
        projects={projects}
        inlineLayout
      />
    );
  }

  if (selectedBatchId) {
    return (
      <BatchDetailPanel
        batchId={selectedBatchId}
        initialSampleId={initialSampleId}
        initialPipeline={initialPipeline}
        onBatchFinalized={onBatchFinalized}
      />
    );
  }

  return (
    <div className="flex h-full items-center justify-center text-slate-500">
      Select a batch from the left or create a new run.
    </div>
  );
}
